<template>
  <div v-if="isPermission && isEditData">
    <div class="row" style="margin: 5px">
      <div class="col-md-12 col-12">
        <h2 class="font-weight-normal">
          {{ $t('createStockOut') }}
        </h2>
      </div>
    </div>
    <CCol md="12" lg="12">
      <CCard class="shadow-sm">
        <CCardBody>
          <CAlert id="createStockOutSuccessAlert" color="success" v-if="isSuccess === true">
            {{ $t('dialogSaveDocumentOutSuccess') }}
          </CAlert>
          <div class="row">
            <div class="col-md-12 col-12">
              <h4 class="font-weight-normal">
                {{ $t('information') }}
              </h4>
            </div>
          </div>
          <br />
          <div class="form-group row">
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('dateOfBill') }}
            </label>
            <div class="col-12 col-md-4">
              <!-- <VueDatePicker id="createStockOutDatePicker" color="#29B46B" :locale="getDateLocale()"
                  :visible-years-number="90" v-model="datetime" format="DD-MM-YYYY" class="form-control text-dark" >
                  <template v-slot="{ inputValue, inputEvents }">
                  <input id="createStockOutDateInput" :value="inputValue"
                    v-on="inputEvents" />
                </template></VueDatePicker> -->
              <v-date-picker v-model="datetime" :locale="getDateLocale()"
                :popover="{ visibility: 'click', placement: 'bottom-start' }">
                <template v-slot="{ inputValue, togglePopover }">
                  <input id="createStockOutDateInput" :value="formatDate(inputValue)" @click="togglePopover" readonly
                    class="form-control text-dark" />
                </template>
              </v-date-picker>
            </div>
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('billNo') }}
            </label>
            <div class="col-12 col-md-4">
              <input id="createStockOutBillNoInput" class="form-control text-dark" v-model="billNo"
                :placeholder="$t('billNo')" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('shop') }}
            </label>
            <div class="col-12 col-md-4">
              <select id="createStockOutShopSelect" class="custom-select text-dark" v-model="shopObjectId" disabled>
                <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                  {{ shop.shopName }} - {{ shop.branchName }}
                </option>
              </select>
              <div id="createStockOutShopValidation" v-if="validateShop" class="text-danger">
                {{ validateShop }}
              </div>
            </div>
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('customer') }}
            </label>
            <div class="col-12 col-md-4">
              <multiselect id="createStockOutCustomerSelect" v-model="member" :options="memberslist" label="name"
                track-by="name" :placeholder="$t('customer')" :select-label="$t('pressEnterSelect')"
                :selected-label="$t('selected')" :deselect-label="$t('pressEnterRemove')"></multiselect>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('StockOutType') }}
            </label>
            <div class="col-12 col-md-4">
              <select id="createStockOutTypeSelect" class="custom-select text-dark"
                v-if="category" v-model="category.id" @change="onCategoryChange">
                <option v-for="item in enabledTypeOptions" :key="item.id" :value="item.id">
                  {{ item.nameTranslation[$i18n.locale.toUpperCase()] || item.name }}
                </option>
              </select>
              <select v-else class="custom-select text-dark">
                <option></option>
              </select>
              <a href="javascript:void(0)"
                class="d-inline-block mt-1 small"
                style="color: #39f; text-decoration: none;"
                @click="manageCategoryModal = true">
                <i class="fi fi-rr-settings" style="font-size: 0.75rem;"></i>
                {{ $t('manageType') || 'จัดการประเภท' }}
              </a>
            </div>
            <label class="col-12 col-md-2 col-form-label text-sm-right text-left">
              {{ $t('reason') }}
            </label>
            <div class="col-12 col-md-4">
              <textarea id="createStockOutReasonTextarea" v-model="note" class="form-control text-dark"
                :placeholder="$t('reason')" />
            </div>
          </div>
        </CCardBody>
      </CCard>
      <CCard class="shadow-sm">
        <CCardBody>
          <div class="row">
            <div class="col-md-5">
              <h4 class="font-weight-normal">
                {{ $t('stockOutList') }}
              </h4>
              <p>
                {{ $t('addstockOutList') }}
              </p>
            </div>
            <div class="col-md-4 col-8 text-right">
              <CButton id="createStockOutImportDocButton" class="btn btn-outline-success btn-block"
                style="display: flex; align-items: center; justify-content: center;" @click="AddCheckStockModalOpen()">
                <i class="fi fi-rr-plus" style="margin-right: 8px;"></i> {{ $t('importcheckStockDoc') }}
              </CButton>
            </div>
            <div class="col-md-3 col-4 text-right">
              <CButton id="createStockOutAddProductButton" class="btn btn-outline-success btn-block"
                @click="AddModal()" style="display: flex; align-items: center; justify-content: center;">
                <i class="fi fi-rr-plus" style="margin-right: 8px;"></i>{{ $t('addProduct') }}
              </CButton>
            </div>
          </div>

          <CRow class="mt-3">
            <CCol sm="12" lg="12">
              <table id="createStockOutProductTable" style="white-space: nowrap;" v-if="items.length !== 0"
                class="table table-sm table-responsive table-bordered text-dark font-weight-normal">
                <thead>
                  <tr>
                    <th class="text-dark text-center font-weight-normal">#</th>
                    <th></th>
                    <th class="text-dark font-weight-normal">{{ $t('pluCode') }}</th>
                    <th class="text-dark font-weight-normal">{{ $t('productName') }}</th>
                    <th class="text-dark font-weight-normal">{{ $t('unit') }}</th>
                    <th class="text-dark text-right font-weight-normal">{{ $t('quantity') }}</th>
                    <th class="text-dark text-right font-weight-normal">{{ $t('stockUnit') }}</th>
                    <th class="text-dark text-right font-weight-normal">{{ $t('discount') }}</th>
                    <th class="text-dark text-right font-weight-normal">{{ $t('total') }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td :id="'itemIndex' + index" style="width: 2%;" class="text-center"
                      :value="(item.orderIndex = index)">
                      <div style="margin-top:6px;">
                        {{ index + 1 }}
                      </div>
                    </td>
                    <td style="width:5%">
                      <div v-if="item.remoteImagePath" :style="{
                        'background-image': `url('${item.remoteImagePath}'), url('${noImg}')`,
                        'background-size': 'cover',
                        'background-position': 'center center',
                        'width': 'auto',
                        'border-radius': '2px',
                        'aspect-ratio': '1.3',
                        'min-width': '50px',
                      }"></div>
                      <div v-else style="border-radius: 2px" :style="{
                        'aspect-ratio': '4 / 3',
                        'min-width': '50px',
                        backgroundColor: item.indexColor,
                      }"></div>
                    </td>
                    <td>
                      <div style="margin-top:6px;">
                        {{ item.productPLU.PLUCode }}
                      </div>
                    </td>
                    <td style="width:30%">
                      <div :id="'createStockOutName' + index" class="text-dark font-weight-normal"
                        style="margin-top: 6px">
                        <span v-if="item.vatType === 'N'">
                          {{ item.productPLU.name || '' }}
                          <small v-if="item.docNo" class="text-muted ml-1"> ({{ item.docNo }}) </small>
                          <CBadge color="danger">Non VAT</CBadge>
                        </span>

                        <span v-else>
                          {{ item.productPLU.name || '' }}
                          <small v-if="item.docNo" class="text-muted ml-1"> ({{ item.docNo }}) </small>
                        </span>

                      </div>
                    </td>
                    <td>
                      <div style="margin-top:6px;">
                        {{ item.productPLU.unit ? (item.productPLU.unit.name || '-') : '-' }}/{{
                          item.productPLU.SKURatio || '1'
                        }}
                      </div>
                    </td>
                    <td>
                      <input style="width:100%; height:100%;" type="number" min="0" v-model.number="item.quantity"
                        class="form-control form-control-md text-right text-dark" />
                      <p class="text-danger" v-if="
                        Number(item.quantity < 0) ||
                        Number.isNaN(parseInt(item.quantity))
                      ">
                        {{ $t('dialogfound') }}
                      </p>
                    </td>
                    <td>
                      <input style="width:100%; height:100%;" type="number"
                        class="form-control form-control-md text-right text-dark" v-model.number="item.cost" />
                    </td>
                    <td>
                      <input style="width:100%; height:100%;"
                        class="form-control form-control-md text-right text-danger" v-model.number="item.discount" />
                    </td>
                    <td>
                      <input style="width:100%; height:100%;" class="form-control form-control-md text-right text-dark"
                        :value="grandTotalItem(item)" disabled />
                    </td>
                    <td class="text-center" style="width:2%">
                      <CButton :id="'createStockOutDelteItemButton' + index" color="danger" size="sm"
                        @click="removeProduct(item)">
                        <CIcon name="cil-trash"></CIcon>
                      </CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
              <CDataTable v-else>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8;">
                      {{ $t('noItem') }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
              <div v-if="validateItem" class="text-danger" id="createStockOutValidationMessage">
                {{ validateItem }}
              </div>
              <p id="createStockOutWarningMessage" class="text-danger" v-if="warning != ''">{{ warning }}</p>
              <p id="createStockOutDuplicateItemMessage" v-if="duplicateItem != ''" class="text-danger">
                {{ duplicateItem }}
              </p>

            </CCol>
          </CRow>


          <br v-if="items.length != 0" />
          <div class="row justify-content-end" v-if="items.length != 0">
            <div id="createStockOutVATSwitchLabel" class="col-md-3 col-6 text-right">
              <p v-if="isVatIncluded === false">{{ $t('isVatIncluded') }}</p>
              <p v-else-if="isVatIncluded === true">
                {{ $t('vatIccludes') }}
              </p>
              <CSwitch id="createStockOutVATSwitch" v-model="isVatIncluded" color="success" :value="isVatIncluded"
                :checked.sync="isVatIncluded" />
            </div>
            <div id="createStockOutNetTotal" class="col-md-2 col-6 text-right">
              <p>{{ $t('totalNet') }}</p>
              <h4>{{ netTotalCurrencyString }}</h4>
            </div>
            <div id="createStockOutDiscountTotal" class="col-md-2 col-6 text-right">
              <p>{{ $t('discount') }}</p>
              <h4 class="text-right  " style="padding-left: 30px;">
                <input id="createStockOutDiscountInput" style="margin-top: -5px;" v-model="discount"
                  class="form-control form-control-md mx-auto text-right text-danger " />
              </h4>
            </div>
            <div id="createStockOutVATTotal" class="col-md-2 col-6 text-right">
              <p>{{ $t('vat') }} 7%</p>
              <h4>{{ vatCurrencyString }}</h4>
            </div>
            <div id="createStockOutGrandTotal" class="col-md-2 col-6 text-right">
              <p>{{ $t('grandTotal') }}</p>
              <h4>{{ grandTotal }}</h4>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol>
      <div class="row justify-content-end" style="margin: 0">
        <CButton id="createStockOutSaveButton" class="btn btn-success  col-lg-2 col-4" style="margin-right: 15px;"
          @click="handlePopup" v-if="items.length != 0">
          {{ $t('save') }}
        </CButton>
        <CButton class="btn btn-success col-lg-2 col-4" style="margin-right: 15px;" v-else disabled>
          {{ $t('save') }}
        </CButton>
        <CButton id="createStockOutSaveButtonDisabled" class="btn col-lg-2 col-4 shadow-sm font-weight-normal"
          style="background-color: white;" @click="$router.go(-1)">
          {{ $t('cancel') }}
        </CButton>
      </div>
      <br />
    </CCol>
    <CRow>
      <CModal id="createStockOutModal" :show.sync="popupModal" color="success font-weight-normal"
        :title="$t('confirmSaveDoc')" centered :footer="footer">
        <br />
        <h4 class="text-center font-weight-normal">{{ $t('confirmSaveDocStockOutModal') }}</h4>
        <br />
        <template #footer>
          <CRow class="justify-content-center col-md-12">
            <CCol col="4">
              <CButton id="createStockOutSaveButton" block color="success" v-if="loadingButton === true"
                v-on:click="formSubmit">
                {{ $t('save') }}
              </CButton>
              <CButton id="createStockOutSaveButtonDisabled" block color="success" v-else-if="loadingButton === false"
                disabled>
                <CSpinner color="white" size="sm" /> {{ $t('save') }}
              </CButton>
            </CCol>
            <CCol col="2"></CCol>
            <CCol col="4">
              <CButton id="createStockOutCancelButton" block color="light" @click="popupModal = false">
                {{ $t('cancel') }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </CRow>
    <CRow>
      <CModal id="createStockOutAddProductModal" :show.sync="AddProductModal" centered style="max-width: 915px;"
        :footer="footer" size="lg">
        <template #header-wrapper class="header-modal">
          <header class="modal-header header-modal">
            <h4 class="modal-title font-weight-normal">
              {{ $t('selectdProduct') }}
            </h4>
            <button id="createStockOutModalCloseButton" type="button" aria-label="Close" class="close"
              @click="AddProductModal = false">
              ×
            </button>
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <CRow class="mb-3">
              <label class="col-sm-1 col-form-label text-left text-dark font-weight-normal">
                {{ $t('search') }}
              </label>
              <CCol style="padding-right: 0;">
                <select id="createStockOutSearchBySelect" v-model="searchBy"
                  class="custom-select no-border-radius-left">
                  <option value="PLUCode">{{ $t('pluCode') }}</option>
                  <option value="name">{{ $t('productName') }}</option>
                  <option value="category">{{ $t('category') }}</option>
                </select>
              </CCol>
              <CCol class="pl-0 col-6">
                <template v-if="searchBy === 'category'">
                  <select id="createStockOutCategorySelect" v-model="selectedCategory"
                    class="form-control text-dark no-border-radius-right" :placeholder="$t('selectCategory')">
                    <option selected value="">{{ $t('selectCategory') }}</option>
                    <option v-for="category in dataCategory" :key="category.objectId" :value="category.objectId">
                      {{ category.name }}
                    </option>
                  </select>
                </template>
                <template v-else>
                  <input id="createStockOutKeywordInput" class="form-control text-dark no-border-radius-right"
                    v-model="keywordEntered" @keyup.enter="searchProductPLU" :placeholder="$t('searchProduct')" />
                </template>
              </CCol>

              <CCol class="p-0">
                <CButton id="createStockOutSearchButton" block color="success" v-if="loadingButton === true"
                  v-on:click="searchProductPLU">
                  {{ $t('search') }}
                </CButton>
              </CCol>
              <CCol>
                <CButton id="createStockOutResetButton" class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="font-weight: bold; color: black; width: inherit" v-on:click="reset">
                  {{ $t('reset') }}
                </CButton>
              </CCol>
            </CRow>
            <div v-if="checkAllAlert" class="alert alert-warning  mt-2 mb-0" style="font-size: 13px;">
              <i class="fi fi-rr-info mr-1"></i> การเลือกทั้งหมด จะเลือกเฉพาะสินค้าในหน้านี้เท่านั้น หากต้องการเลือกสินค้าเพิ่ม กรุณาเปลี่ยนหน้าแล้วเลือกเพิ่มเติม
            </div>
            <div id="createStockOutProductList" style="max-height: 400px; overflow-y: auto;" >
              <CDataTable id="createStockOutDataTable" :fields="fields" :items="autoCompleteResult" hover
                v-model="autoCompleteResult" border clickableRows @row-clicked="onSelectedAutoCompleteEvent" >
                <template slot="selected-header">
                  <div id="createStockOutSelectedHeader" class="custom-control custom-checkbox"
                    style="padding-left: 2rem">
                    <input v-model="all" type="checkbox" @change="setAll()" class="custom-control-input success cursor"
                      id="yyy" />
                    <label class="custom-control-label cursor" for="yyy">
                    </label>
                  </div>
                </template>
                <template #selected="{ item, index }">
                  <td :id="'createStockOutRowSelected' + index" style="vertical-align: middle;">
                    <div class="custom-control custom-checkbox" style="padding-left: 2rem">
                      <input type="checkbox" class="custom-control-input success cursor" :disabled="item.inDocument" v-model="item.selected"
                        @change="onSelectedAutoCompleteEvent(item)" :id="index" />
                      <label class="custom-control-label cursor" :for="index">
                      </label>
                    </div>
                  </td>
                </template>
                <template #name="{ item, index }">
                  <td :id="'createStockOutItemName' + index" style="vertical-align: middle;border-left: hidden;"
                    :for="index">
                    <img :id="'createStockOutItemImage' + index" v-if="item.remoteImagePath" :src="item.remoteImagePath"
                      style="border-radius: 2px;aspect-ratio: 4 / 3;" class="img-fluid" @error="noImgUrl" />
                    <div v-else style="border-radius: 2px" :style="{
                      'aspect-ratio': '4 / 3',
                      backgroundColor: item.indexColor,
                    }"></div>
                  </td>
                </template>
                <template #nameproduct="{ item, index }">
                  <td :id="'createStockOutProductName' + index" class="text-dark"
                    style="vertical-align: middle;border-left: hidden;">
                    {{ item.name }}
                  </td>
                </template>
                <template #categoryName="{ item, index }">
                  <td :id="'createStockOutCategoryName' + index" class="text-dark font-weight-normal"
                    style="vertical-align: middle;border-left: hidden;">
                    {{ item.categoryName }}
                  </td>
                </template>
                <template #pluCode="{ item, index }">
                  <td :id="'createStockOutPLUCode' + index" class="text-dark"
                    style="vertical-align: middle;border-left: hidden;">
                    {{ item.PLUCode }}
                  </td>
                </template>
                <template #price="{ item, index }">
                  <td :id="'createStockOutItemPrice' + index" :for="index"
                    style="vertical-align: middle;border-left: hidden " v-if="
                      item.ProductSKU.stdCost === '' ||
                      item.ProductSKU.stdCost === undefined
                    ">
                    ฿ 0
                  </td>
                  <td :id="'createStockOutItemPrice' + index" :for="index"
                    style="vertical-align: middle;border-left: hidden " v-else>
                    ฿ {{ item.ProductSKU.stdCost }}
                  </td>
                </template>
                <template #onhanQTY="{ item, index }">
                  <td :id="'createStockOutOnhandQty' + index" class="text-right" :for="index"
                    style="vertical-align: middle; border-left: hidden" v-if="
                      item.ProductPLUStock.onhandQty === '' ||
                      item.ProductPLUStock.onhandQty === undefined
                    ">
                    N/A
                  </td>
                  <td :id="'createStockOutOnhandQty' + index" class="text-right" :for="index"
                    style="vertical-align: middle; border-left: hidden" v-else>
                    <div
                      v-if="item.ProductPLUStock.onhandQty < 0 && Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))"
                      class="text-danger">
                      {{ parseFloat(item.ProductPLUStock.onhandQty) }}
                    </div>
                    <div
                      v-else-if="item.ProductPLUStock.onhandQty < 0 && !Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))"
                      class="text-danger">
                      {{ parseFloat(item.ProductPLUStock.onhandQty).toFixed(3) }}
                    </div>
                    <div v-else-if="!Number.isInteger(parseFloat(item.ProductPLUStock.onhandQty))" class="text-dark">
                      {{ parseFloat(item.ProductPLUStock.onhandQty).toFixed(3) }}
                    </div>
                    <div v-else class="text-dark">
                      {{ parseFloat(item.ProductPLUStock.onhandQty) }}
                    </div>
                  </td>
                </template>
                <template #no-items-view>
                  <div :id="'createStockOutNoItems'" class="text-center my-5">
                    <h4 style="color: #ced2d8;">
                      {{ $t('noItem') }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
            </div>
            <pagination :meta_data="meta_data_product" v-on:next="searchProductPLU">
            </pagination>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <CRow class="justify-content-end col-md-12">
            <CCol col="12" lg="6" class="row">
              <div class="col-6">
                <CButton id="createStockOutConfirmButton" block color="success" v-if="loadingButton === true"
                  v-on:click="onCheckboxChange">
                  {{ $t('confirm') }}
                </CButton>
                <CButton id="createStockOutSaveDisabledButton" block color="success" v-else-if="loadingButton === false"
                  disabled>
                  <CSpinner color="white" size="sm" /> {{ $t('save') }}
                </CButton>
              </div>
              <div class="col-6">
                <CButton id="createStockOutCancelButton" class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="font-weight: bold; width: inherit" @click="AddProductModal = false">
                  {{ $t('cancel') }}
                </CButton>
              </div>
            </CCol>
          </CRow>
          <br />
        </template>
      </CModal>
    </CRow>
    <CRow>
      <CModal :id="'createStockOutAddCheckStockModal'" :show.sync="AddCheckStockModal" centered :footer="footer"
        size="lg" style="max-width: 915px;">
        <template #header-wrapper class="header-modal">
          <header class="modal-header header-modal">
            <h4 class="modal-title font-weight-normal">
              {{ $t('selectCheckStockDoc') }}
            </h4>
            <CButton :id="'createStockOutCreateCheckStockButton'" to="/inventory/check-stock/create" color="warning">
              <i class="fi fi-rr-plus" style="margin-right: 8px;"></i> {{ $t('createCheckStock') }}
            </CButton>
            <!-- <button type="button" aria-label="Close" class="close" @click="AddCheckStockModal = false">
              ×
            </button> -->
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <CRow class="mb-3">
              <label class="col-sm-1  col-form-label text-left text-dark">
                {{ $t('search') }}
              </label>
              <CCol style="padding-right: 0;">
                <select id="createStockInSearchBySelect" v-model="searchDocBy"
                  class="custom-select no-border-radius-left">
                  <option value="note">{{ $t('checkStockName') }}</option>
                  <option value="checkStockNo">{{ $t('documentNo') }}</option>
                  <!-- <option value="created_at">{{ $t('category') }}</option> -->
                </select>
              </CCol>
              <CCol class="pl-0 col-6">
                <template>
                  <input id="createStockInSearchInput" class="form-control text-dark no-border-radius-right"
                    v-model="keywordDocEntered" @keyup.enter="getCheckStock(1)" :placeholder="$t('searchProduct')" />
                </template>
              </CCol>
              <CCol class="p-0">
                <CButton id="createStockInSearchButton" block color="success" v-if="loadingButton === true"
                  v-on:click="getCheckStock(1)">
                  {{ $t('search') }}
                </CButton>
              </CCol>
              <CCol class="pl-1">
                <CButton id="createStockInResetButton" class="btn btn-outline-secondary text-dark font-weight-normal"
                  style="color: black; width: inherit" v-on:click="resetDoc">
                  {{ $t('reset') }}
                </CButton>
              </CCol>
            </CRow>
            <div style="max-height: 400px; overflow-y: auto;">
              <CDataTable :id="'createStockOutCheckStockDataTable'" :fields="checkStockFields" :items="checkStockItem"
                hover border v-model="checkStockItem" clickableRows @row-clicked="onSelectCheckStockDoc">

                <!-- <template slot="selected-header">
                  <div class="custom-control custom-checkbox" style="padding-left: 2rem">
                    <input v-model="all" type="checkbox" @change="setAll()" class="custom-control-input success cursor"
                      id="checkbox" />
                    <label class="custom-control-label cursor" for="checkbox">
                    </label>
                  </div>
                </template> -->
                <template slot="nameproduct-header">
                  <p></p>
                </template>
                <template #selected="{ item, index }">
                  <td :id="'createStockOutRowSelected' + index" style="vertical-align: middle; text-align: center;">
                    <div class="custom-control custom-checkbox " style="padding-left: 2rem">
                      <input type="checkbox" class="custom-control-input success cursor" v-model="item.selected"
                        @change="onSelectCheckStockDoc(item)" :id="index" />
                      <label class="custom-control-label cursor" :for="index">
                      </label>
                    </div>
                  </td>
                </template>
                <template #name="{ item, index }">
                  <td :id="'createStockOutItemName' + index" class="text-dark" style="vertical-align: middle;">
                    {{ item.note }}
                  </td>
                </template>
                <template #no-items-view>
                  <div :id="'createStockOutNoItemsView'" class="text-center my-5">
                    <h4 style="color: #ced2d8;">
                      {{ $t('noItem') }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
            </div>
            <pagination :meta_data="meta_data" v-on:next="getCheckStock">
            </pagination>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <CRow class="justify-content-end col-md-12">
            <CCol col="12" lg="6" class="row">
              <div class="col-6">
                <CButton id="'createStockOutConfirmButton'" block color="success" v-if="loadingButton === true"
                  v-on:click="onCheckboxChange">
                  {{ $t('confirm') }}
                </CButton>
                <CButton id="'createStockOutSaveButton'" block color="success" v-else-if="loadingButton === false"
                  disabled>
                  <CSpinner color="white" size="sm" /> {{ $t('save') }}
                </CButton>
              </div>
              <div class="col-6">
                <CButton id="'createStockOutCancelButton'"
                  class="btn btn-outline-secondary text-dark font-weight-normal" style="width: inherit"
                  @click="AddCheckStockModal = false">
                  {{ $t('cancel') }}
                </CButton>
              </div>
            </CCol>
          </CRow>
          <br />
        </template>
      </CModal>
    </CRow>
    <!-- Manage Category Modal -->
    <CRow>
      <CModal
        id="manageCategoryModal"
        :show.sync="manageCategoryModal"
        centered
        size="lg"
      >
        <template #header-wrapper>
          <header class="modal-header" style="background-color: #3c4b64; color: #fff; border-radius: 0.3rem 0.3rem 0 0;">
            <h5 class="modal-title font-weight-normal" style="display: flex; align-items: center;">
              <i class="fi fi-rr-settings mr-2"></i>
              {{ $t('manageStockOutType') || 'จัดการประเภทสินค้าออก' }}
            </h5>
            <button type="button" aria-label="Close" class="close text-white" @click="manageCategoryModal = false">
              ×
            </button>
          </header>
        </template>
        <template #body-wrapper>
          <CCardBody>
            <!-- Create new category form (compact inline) -->
            <div class="mb-3 p-3" style="background: #f8f9fa; border-radius: 8px; border: 1px solid #e8e8e8;">
              <h6 class="font-weight-bold text-dark mb-3" style="font-size: 0.95rem;">
                <i class="fi fi-rr-plus-small mr-1"></i>
                {{ $t('addStockOutType') || 'เพิ่มประเภทใหม่' }}
              </h6>
              <div class="row align-items-start">
                <div class="col-12  col-lg-3 col-md-4  mb-md-0">
                  <label class="small text-muted mb-1">
                    {{ $t('stockOutTypeName') || 'ชื่อ' }} <span class="text-danger">*</span>
                  </label>
                  <input id="newCategoryName" 
                    class="form-control form-control-sm text-dark"
                    :class="{ 'is-invalid': manageCategoryValidate && !newCategoryName.trim() }"
                    v-model="newCategoryName" :placeholder="'เช่น ยืม'" />
                  <div class="invalid-feedback" style="font-size: 0.75rem;">
                    {{ $t('validateName') || 'กรุณากรอกชื่อ' }}
                  </div>
                </div>
                <div class="col-12 col-lg-3  col-md-4  mb-md-0">
                  <label class="small text-muted mb-1">{{ $t('nameTH') || 'ชื่อ (TH)' }}</label>
                  <input id="newCategoryNameTH"
                    class="form-control form-control-sm text-dark"
                    v-model="newCategoryNameTH" :placeholder="'ยืม'" />
                </div>
                <div class="col-12 col-lg-3  col-md-4  mb-md-0">
                  <label class="small text-muted mb-1">{{ $t('nameEN') || 'ชื่อ (EN)' }}</label>
                  <input id="newCategoryNameEN"
                    class="form-control form-control-sm text-dark"
                    v-model="newCategoryNameEN" :placeholder="'Borrow'" />
                </div>
                <div class="col-12  col-lg-3  col-md-12  mb-md-0 mt-0">
                  <label class="small text-muted mb-1">&nbsp;</label>
                  <CButton
                    color="success"
                    size="sm"
                    block
                    @click="createStockOutCategory"
                    :disabled="false"
                    style="height: 31px;"
                  >
                    <i class="fi fi-rr-plus" style="margin-right: 4px;"></i>
                    {{ $t('addStockOutType') || 'เพิ่มประเภท' }}
                  </CButton>
                </div>
              </div>
              <CAlert color="success" v-if="manageCategorySuccess" class="mt-2 mb-0 py-1 px-2" style="font-size: 0.85rem;">
                {{ manageCategorySuccess }}
              </CAlert>
              <CAlert color="danger" v-if="manageCategoryError" class="mt-2 mb-0 py-1 px-2" style="font-size: 0.85rem;">
                {{ manageCategoryError }}
              </CAlert>
            </div>

            <!-- List existing categories -->
            <h6 class="font-weight-bold text-dark mb-2" style="font-size: 0.95rem;">
              {{ $t('existingTypes') || 'รายการประเภททั้งหมด' }}
              <CBadge color="info" class="ml-1">{{ typeOptions.length }}</CBadge>
            </h6>
            <div style="max-height: 350px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 6px;">
              <table class="table table-striped table-hover table-sm text-dark mb-0" v-if="typeOptions.length > 0">
                <thead style="background: #e9ecef; position: sticky; top: 0; z-index: 1;">
                  <tr>
                    <th class="font-weight-normal text-center" style="width: 10px;">#</th>
                    <th class="font-weight-normal">{{ $t('stockOutTypeName') || 'ชื่อ' }}</th>
                    <th class="font-weight-normal text-right" style="width: 90px;">{{ $t('manageStockOutType') || 'จัดการ' }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in typeOptions" :key="item.id">
                    <td class="text-center" style="width: 10px;"> {{ index + 1 }}</td>
                    <td>
                      <div class="font-weight-bold">{{ item.name || '-' }}</div>
                      <small class="text-muted" v-if="item.nameTranslation">
                        <span v-if="item.nameTranslation.TH">TH: {{ item.nameTranslation.TH }}</span>
                        <span v-if="item.nameTranslation.TH && item.nameTranslation.EN"> | </span>
                        <span v-if="item.nameTranslation.EN">EN: {{ item.nameTranslation.EN }}</span>
                      </small>
                    </td>
                    <td class="text-right" style="width: 90px;">
                      <CButton
                        variant="ghost"
                        color="danger"
                        size="sm"
                        @click="deleteStockOutCategory(item.id)"
                        v-if="item.id > 7"
                        style="padding: 2px 8px;"
                      >
                        <CIcon name="cil-trash" size="sm"></CIcon>
                      </CButton>
                      <span v-else class="text-muted small"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="typeOptions.length === 0" class="text-center text-muted my-3">
              <i class="fi fi-rr-inbox-full" style="font-size: 2rem; opacity: 0.4;"></i>
              <br />
              {{ $t('noItem') || 'ไม่มีรายการ' }}
            </div>
          </CCardBody>
        </template>
        <template #footer-wrapper>
          <div class="modal-footer" style="border-top: 1px solid #e8e8e8;">
            <CButton color="secondary" variant="outline" @click="manageCategoryModal = false">
              {{ $t('closed') || 'ปิด' }}
            </CButton>
          </div>
        </template>
      </CModal>
    </CRow>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axios from '@/services/local'
import util from '@/util/util'
import Multiselect from 'vue-multiselect'
import permis from '@/util/permission'
import pos from '@/services/local'
import Pagination from '@/containers/Pagination'

export default {
  components: {
    Multiselect,
    Pagination,
  },
  data() {
    return {
      checkAllAlert: false,
      meta_data_product: {
        last_page: null,
        current_page: 1,
        items: 0,
        limit: 20,
        itemCount: null,
      },
      isSuccess: false,
      alert: false,
      data: [],
      datetime: new Date(),
      shop: this.$store.getters.shopObjectId,
      member: null,
      members: {},
      isVatIncluded: false,
      category: null,
      typeOptions: [],
      billNo: '',
      note: '',
      discount: '0',
      searchBy: 'name',
      label: 'name',
      keyword: '',
      itemNetTotal: '0.00',
      placeHolderInputText: 'พิมพ์ชื่อสินค้าที่ต้องการค้นหา .​.​.',
      autoCompleteResult: [],
      autoCompleteProgress: false,
      autoCompleteText: 'name',
      autoCompleteText2: 'PLUCode',
      autoCompleteText3: 'unitName',
      autoCompleteFieldId: 'alpha3Code',
      items: [],
      vatType: '',
      // itemList: [],
      validateShop: '',
      validateItem: '',
      popupModal: false,
      footer: '',
      loadingButton: true,
      duplicateItem: '',
      warning: '',
      AddProductModal: false,
      AddCheckStockModal: false,
      keywordEntered: '',
      selectedItems: [],
      all: false,
      checkStockItem: [],
      dataCategory: [],
      selectedCategory: '',
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      searchDocBy: 'note',
      keywordDocEntered: '',
      // Manage Category Modal
      manageCategoryModal: false,
      newCategoryName: '',
      newCategoryNameTH: '',
      newCategoryNameEN: '',
      manageCategorySuccess: '',
      manageCategoryError: '',
      manageCategoryValidate: false,
    }
  },
  computed: {
    ...mapGetters(['shops', 'users', 'date']),
    enabledTypeOptions() {
      return this.typeOptions.filter(item => item.enabled)
    },
    uid() {
      return `${localStorage.getItem('shopsUid')}`
    },
    isPermission() {
      let path = '/inventory/stock-out'
      return permis.findPermissionRead('inventory', path)
    },
    isEditData() {
      let path = '/inventory/stock-out'
      return permis.findPermissionEdit('inventory', path)
    },

    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId
      },
      set(newValue) {
        return this.$store.dispatch('setShop', newValue)
      },
    },
    startDate() {
      return moment(String(this.date.start)).format('DD MMMM YYYY')
    },
    vat() {
      let vat = 0;
      this.items.forEach(item => {
        vat += this.calculateVat(item);
      });

      return vat;
    },
    vatCurrencyString() {
      return util.convertCurrency(this.vat);
    },
    grandTotal() {
      let grandTotal = ''
      let summary = this.netTotal || 0
      let vat = this.vat || 0

      if (this.isVatIncluded === false) {
        grandTotal = summary - this.discount
      } else if (this.isVatIncluded === true) {
        grandTotal = summary + vat - this.discount
      }

      return util.convertCurrency(grandTotal)
    },
    netTotal() {
      let total = 0;
      this.items.forEach(item => {
        total += this.grandTotalItem(item);
      });
      return total;
    },
    netTotalCurrencyString() {
      return util.convertCurrency(this.netTotal)
    },

    noImg() {
      return process.env.VUE_APP_NOIMAGE
    },
    fields() {
      return [
        {
          key: 'selected',
          label: this.$i18n.t('selectd'),
          _style: 'width:5%; vertical-align: middle;',
          _classes: 'text-left text-dark font-weight-normal',
        },
        {
          key: 'name',
          label: '',
          _style: 'width:7%; vertical-align: middle;border-left: hidden',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'nameproduct',
          label: this.$i18n.t('product'),
          _style: 'width:30%; vertical-align: middle;border-left: hidden',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'pluCode',
          label: this.$i18n.t('pluCode'),
          _style: 'width:23%; vertical-align: middle;border-left: hidden',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'categoryName',
          label: this.$i18n.t('category'),
          _style: 'width:22%; vertical-align: middle;',
          _classes: 'text-left font-weight-normal text-dark',
        },
        {
          key: 'onhanQTY',
          label: this.$i18n.t('onhandQty'),
          _classes: 'text-right font-weight-normal  text-dark',
          _style: 'width:30%; vertical-align: middle;border-left: hidden',
        },
      ]
    },
    memberslist() {
      const member = this.members || []
      let detail = []
      for (let i = 0; i < member.length; i++) {
        const item = member[i]
        const fullName = (item.firstname || item.name || '') + ' ' + (item.lastname || '')
        detail.push({
          id: item.id,
          objectId: item.objectId,
          name: fullName,
        })
      }
      return detail
    },
    checkStockFields() {
      return [
        {
          key: 'selected',
          label: this.$i18n.t('selectd'),
          _style: 'width:10%; vertical-align: middle;',
          _classes: 'text-center text-dark font-weight-normal',
        },
        {
          key: 'createdDate',
          label: this.$t('createdAt'),
          _style: 'width:20%; vertical-align: middle;',
          _classes: 'font-weight-normal text-dark',
        },
        {
          key: 'checkStockNo',
          label: this.$t('documentNo'),
          _style: 'width:20%; vertical-align: middle;',
          _classes: 'font-weight-normal text-dark',
        },
        {
          key: 'name',
          label: this.$i18n.t('checkStockName'),
          _style: 'width:40%; vertical-align: middle;',
          _classes: 'text-left text-dark font-weight-normal',
        },
        {
          key: 'createdBy',
          label: this.$t('saveBy'),
          _style: 'width:30%; vertical-align: middle;',
          _classes: 'font-weight-normal text-dark',
        }
      ]
    },
  },
  created() {
    this.getMember()
    this.getStockOutCategory()
    this.getCategory()
    this.shop = this.shops.find((i) => i.objectId === this.shop)
  },
  methods: {
    ...util,
    AddModal() {
      this.keywordEntered = ''
      this.autoCompleteResult = []
      this.all = false
      this.searchProductPLU()
      this.AddProductModal = true
    },
    AddCheckStockModalOpen() {
      this.getCheckStock()
      this.AddCheckStockModal = true
    },
    onCategoryChange() {
      const selected = this.typeOptions.find(item => item.id === this.category.id)
      if (selected) {
        this.category = { ...selected }
      }
    },
    createStockOutCategory() {
      this.manageCategorySuccess = ''
      this.manageCategoryError = ''
      this.manageCategoryValidate = true

      if (!this.newCategoryName.trim()) {
        return
      }

      const shopObjectId = this.shopObjectId
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      const name = this.newCategoryName.trim()
      const data = {
        name: name,
        enabled: true,
        nameTranslation: {
          TH: this.newCategoryNameTH.trim() || name,
          EN: this.newCategoryNameEN.trim() || name,
        },
      }
      axios
        .post('/api/v3.0/shop/stock/export/category', data, { headers })
        .then((res) => {
          this.manageCategorySuccess = this.$t('saveSuccess') || 'บันทึกสำเร็จ'
          this.newCategoryName = ''
          this.newCategoryNameTH = ''
          this.newCategoryNameEN = ''
          this.manageCategoryValidate = false
          this.getStockOutCategory()
          setTimeout(() => {
            this.manageCategorySuccess = ''
          }, 3000)
        })
        .catch((error) => {
          console.error('Error creating stock out category:', error)
          this.manageCategoryError = this.$t('saveFail') || 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง'
          setTimeout(() => {
            this.manageCategoryError = ''
          }, 3000)
        })
    },
    deleteStockOutCategory(categoryId) {
      if (!confirm(this.$t('confirmDeleteStockType') || 'คุณต้องการลบประเภทสินค้าออกนี้หรือไม่?')) {
        return
      }
      this.manageCategorySuccess = ''
      this.manageCategoryError = ''
      const shopObjectId = this.shopObjectId
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      axios
        .delete('/api/v3.0/shop/stock/export/category/' + categoryId, { headers })
        .then((res) => {
          this.manageCategorySuccess = this.$t('deleteSuccess') || 'ลบสำเร็จ'
          this.getStockOutCategory()
          setTimeout(() => {
            this.manageCategorySuccess = ''
          }, 3000)
        })
        .catch((error) => {
          console.error('Error deleting stock out category:', error)
          this.manageCategoryError = this.$t('deleteFail') || 'ลบไม่สำเร็จ กรุณาลองอีกครั้ง'
          setTimeout(() => {
            this.manageCategoryError = ''
          }, 3000)
        })
    },
    getStockOutCategory() {
      const uid = `${localStorage.getItem('shopsUid')}`
      const shopObjectId = this.shopObjectId
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      axios
        .get('/api/v3.0/shop/stock/export/category', {
          params: { onlyDefault: true },
          headers,
        })
        .then((res) => {
          this.typeOptions = res.data.data || res.data || []
          this.category = this.typeOptions.length > 0
            ? { ...this.typeOptions[0] }
            : null
        })
        .catch((error) => {
          console.error('Error fetching stock out category:', error)
        })
    },
    resetDoc() {
      this.selectedItems = []
      this.searchDocBy = 'note'
      this.keywordDocEntered = ''
      this.getCheckStock(1)
    },
    formatDate(date) {
      if (!date) return ''

      // ถ้าเป็น string (จาก date-picker)
      if (typeof date === 'string') {

        // ถ้า locale = en (ค่าจะมาเป็น MM/DD/YYYY)
        if (this.$i18n.locale === 'en') {
          return moment(date, 'MM/DD/YYYY').format('DD/MM/YYYY')
        }

        // ถ้า locale = th (ค่าจะมาเป็น DD/MM/YYYY อยู่แล้ว)
        if (this.$i18n.locale === 'th') {
          return moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
        }

        // fallback
        return moment(date).format('DD/MM/YYYY')
      }

      // ถ้าเป็น Date object (ดีที่สุด)
      return moment(date).format('DD/MM/YYYY')
    },
    getCategory() {
      const uid = `${localStorage.getItem('shopsUid')}`;
      const shopObjectId = this.shopObjectId;
      let params = {
        page: 1,
        limit: 1000,
      };
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }

      pos
        .get('/api/v1.0/shop/' + uid + '/Category/data/' + shopObjectId, {
          params, headers
        })
        .then((res) => {
          let detail = []
          let data = res.data.data
          for (let i = 0; i < data.length; i++) {
            if (data[i].enabled === true) {
              detail.push({
                id: data[i].id,
                name: data[i].name,
                objectId: data[i].objectId,
              })
            }
          }
          this.dataCategory = detail
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    },
    getCheckStock(page = 1) {
      this.loadingButton = false
      const uid = this.uid
      const shopObjectId = this.shopObjectId
      // const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      // const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      const params = {
        shopObjectId: shopObjectId,
        page: page,
        limit: 50,
      }
       if (this.keywordDocEntered) {
        params.searchAttr = this.searchDocBy
        params.searchVal = this.keywordDocEntered
      }
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      axios({
        url: '/api/v3.0/checkstockdocument',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((res) => {
          this.data = res.data.data
          this.data = this.data.filter(item => item.shop.objectId === this.shopObjectId);

          //pagination
          const paginateData = res.data.paginate || {}
          this.meta_data.items = paginateData.items || 0
          this.meta_data.last_page = paginateData.pageCount || 0
          this.meta_data.current_page = paginateData.currentPage || 0
          this.meta_data.itemCount = paginateData.itemCount || 0
          this.meta_data.limit = paginateData.perPage || 50

          this.loadingButton = true

          const selectedMap = new Set()

          let checkStockDoc = this.data.map(item => {

            if (item.items) {
              item.items = item.items.map(docItem => {
                const objectId = docItem.productPLU?.objectId

                return {
                  ...docItem,
                  selected: selectedMap.has(objectId) // ✅ restore item
                }
              })
            }

            const isSelected = item.items?.some(docItem =>
              selectedMap.has(docItem.productPLU?.objectId)
            )

            return {
              ...item,
              createdDate: moment(String(item.created_at)).format('DD/MM/YYYY HH:mm'),
              createdBy: item.created_by.username || '-',
              selected: isSelected
            }
          })
          this.checkStockItem = checkStockDoc

        })
        .catch((error) => {
          console.log(error)
        })
    },
    onSelectCheckStockDoc(item) {
      // toggle
      item.selected = !item.selected

      if (!item.items || item.items.length === 0) return

      const currentDocRef = item.objectId

      const selectedDoc = item.items.map(docItem => {
        const objectId = docItem.productPLU?.objectId

        const matched = this.autoCompleteResult.find(
          x => x.objectId === objectId
        )

        const stdCost =
          matched?.stdCost ||
          matched?.ProductSKU?.stdCost ||
          docItem.productSKU?.stdCost ||
          0

        return {
          docRef: currentDocRef,
          docNo: item.checkStockNo || '',

          id: docItem.productPLUId || '',
          objectId: objectId,

          PLUCode: docItem.productPLU?.PLUCode || '-',
          name: docItem.productPLU?.name || '-',

          ProductPLU: docItem.productPLU || {},
          ProductSKU: {
            ...docItem.productSKU,
            stdCost: stdCost,
          },

          unit: docItem.productPLU?.unit || {},
          unitName:
            docItem.productPLU?.unit?.name ??
            docItem.unit?.name ??
            '-',

          ProductPLUStock: docItem.ProductPLUStock || {},
          SKURatio: docItem.productPLU?.SKURatio || 1,

          checkCount: docItem.quantity || 0,
          quantity: docItem.quantity || 0,

          shop: docItem.shop || {},
          uid: this.uid || '',

          vatType: docItem.productSKU?.vatType || 'V',

          selected: item.selected,
        }
      })

      // ✅ เลือก
      if (item.selected) {
        selectedDoc.forEach(newItem => {
          const exists = this.selectedItems.some(
            x =>
              x.objectId === newItem.objectId &&
              x.docRef === newItem.docRef
          )

          if (!exists) {
            this.selectedItems.push(newItem)
          }
        })
      }

      // ❌ ยกเลิก
      else {
        this.selectedItems = this.selectedItems.filter(
          x => x.docRef !== currentDocRef
        )
      }
    },
    getDateLocale() {
        return this.$i18n.locale
    },
    noImgUrl(event) {
      event.target.src = process.env.VUE_APP_NOIMAGE
    },
    handlePopup() {
      if (this.shopObjectId === '') {
        this.popupModal = false
        this.validateShop = this.$i18n.t('selectShopPlease')
      } else {
        this.validateShop = ''
      }

      if (this.items.length === 0) {
        this.popupModal = false
        this.validateItem = this.$i18n.t('selectProductPlease')
      } else {
        this.validateItem = ''
      }

      if (this.items.length != 0 && this.shopObjectId != '') {
        this.popupModal = true
      }
    },
    totalQuantity(item) {
      let totalQty = 0;

      for (const item of this.items) {
        totalQty += item.quantity;
      }
      return totalQty;
    },
    calculateDiscount(item) {
      const totalQty = this.totalQuantity();
      let discountPerQty = 0;
      if (totalQty !== 0) {
        discountPerQty = this.discount / totalQty;
      } else {
        discountPerQty = 0;
      }

      return discountPerQty
    },
    grandTotalItem(item) {
      let total = 0
      if (item.vatType === 'N') {
        total = item.quantity * item.cost - item.discount
      }
      if (item.vatType === 'V') {
        total = item.quantity * item.cost - item.discount
      } else {
        total = (item.quantity * item.cost) - item.discount;
      }
      return item.total = total
    },
    grandTotalItemDisperQty(item) {
      let totalnonvat = 0;
      let totalincvat = 0;
      let discountPerQty = this.calculateDiscount();
      if (item && item.vatType === 'N') {
        totalnonvat = item.quantity * item.cost - item.discount - (item.quantity * discountPerQty);
        item.total = totalnonvat;
        return totalnonvat
      } else if (item && item.vatType === 'V') {
        totalincvat = item.quantity * item.cost - item.discount - (item.quantity * discountPerQty);
        item.total = totalincvat;
        return totalincvat
      }
      const total = totalnonvat + totalincvat;
    },

    calculateVat(item) {
      let vat = 0;

      if (item.vatType === 'V' && this.isVatIncluded === false) {
        vat = (this.grandTotalItemDisperQty(item) * 7) / 107;
      }
      else if (item.vatType === 'V' && this.isVatIncluded === true) {
        vat = this.grandTotalItemDisperQty(item) * (7 / 100);
      }
      return vat;
    },
    removeProduct(i) {
      let items = this.items
      let newItems = items.filter((item) => item.orderIndex != i.orderIndex)
      this.items = newItems
      let index = this.autoCompleteResult.findIndex(
        (x) => x.objectId == i.productPLU.objectId
      )
      if (index != -1) {
        this.autoCompleteResult[index].selected = false
      }

      let find = this.selectedItems.findIndex(
        (x) => x.objectId === i.productPLU.objectId
      )
      if (find != -1) {
        this.selectedItems.splice(i, 1)
      }
    },
    getMember() {
      const uid = this.uid
      const shopObjectId = this.shopObjectId

      const params = {
        shopObjectId: shopObjectId,
      }

      axios
        .get('/api/v1.0/' + uid + '/getmember', { params })
        .then((res) => {
          this.members = res.data.data.documents
        })
        .catch((error) => {
          console.log(error)
        })
    },

    onSelectedAutoCompleteEvent(item) {
      if (item.inDocument) return
      item.selected = !item.selected
      if (item.selected) {
        this.selectedItems.push(item)
      } else {
        let i = this.selectedItems.findIndex(
          (x) => x.objectId === item.objectId
        )
        if (i != -1) {
          this.selectedItems.splice(i, 1)
        }
      }
      let countItem = this.autoCompleteResult.length
      let coutselect = 0
      this.autoCompleteResult.forEach(function (item) {
        if (item.selected) {
          coutselect = coutselect + 1
        }
      })
      if (countItem === coutselect) {
        this.all = true
      } else {
        this.all = false
      }
    },
    searchProductPLU(page) {
      if (this.shopObjectId === '') {
        this.validateShop = this.$i18n.t('selectShopPlease')
      } else {
        this.validateShop = ''
      }

      const uid = `${localStorage.getItem('shopsUid')}`
      let params = {}
      if (this.searchBy === 'category' && this.selectedCategory) {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          categoryObjectId: this.selectedCategory,
          page: page || 1,
          limit: 50,
        }
      } else if (this.keywordEntered != '') {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          searchBy: this.searchBy,
          keyword: this.keywordEntered,
          page: page || 1,
          limit: 50,
        }
      } else {
        params = {
          shopObjectId: this.$store.getters.shopObjectId,
          searchBy: this.searchBy,
          page: page || 1,
          limit: 50,
        }
      }
      this.label = this.searchBy
      let selectedItems = this.selectedItems
      // if (keywordEntered.length > 0) {
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(this.$store.getters.shopObjectId),
      }
      axios({
        url: '/api/v1.0/' + uid + '/getproductpluwithstock/paginate',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((response) => {
          this.alert = false
          const paginate = response.data.paginate || {}
          this.meta_data_product.items = paginate.items || 0
          this.meta_data_product.last_page = paginate.pageCount || 0
          this.meta_data_product.current_page = paginate.currentPage || 0
          this.meta_data_product.itemCount = paginate.itemCount || 0
          this.meta_data_product.limit = paginate.perPage || 20
          let newData = []
          response.data.data.forEach((item) => {
            if (selectedItems.length > 0) {
              let i = selectedItems.findIndex(
                (x) => x.objectId === item.objectId
              )
              if (i != -1) {
                item.selected = true
              } else {
                item.selected = false
              }
            } else {
              item.selected = false
            }
            let inDoc = (this.items || []).findIndex(x => (x.productPLU?.objectId || x.productPLU?.id) === item.objectId) !== -1
            if (inDoc) { item.selected = true; item.inDocument = true } else { item.inDocument = false }
            const unit = item.unit || {}
            const category = item.category || {}
            item.unitName = unit.name || '-'
            item.categoryName = category.name || '-'
            item.indexColor = util.generateColor(item.ProductSKU.indexColor)
            if (!item.deleted_at) {
              newData.push(item)
            }
          })
          this.autoCompleteResult = newData
          this.all = newData.length > 0 && newData.every(item => item.selected)
        })
        .catch((e) => {
          this.alert = true
          console.log(e)
        })
      // }
    },
    formSubmit(e) {
      this.shop = this.shops.find((i) => i.objectId === this.shopObjectId)
      this.loadingButton = false
      e.preventDefault()
      let customerId = ''
      let customer = {}
      const plan = this.users.currentPlan

      this.items.forEach(function (item) {
        delete item.remoteImagePath
        delete item.indexColor
      })
      const data = {
        billNo: this.billNo,
        date: new Date(this.datetime).toISOString(),
        discount: util.currencyStringToNumber(this.discount),
        grandTotal: util.currencyStringToNumber(this.grandTotal),
        isVatIncluded: !this.isVatIncluded,
        netTotal: this.netTotal,
        note: this.note,
        shop: {
          id: this.shop.id,
          objectId: this.shop.objectId,
          shopName: this.shop.shopName,
          branchName: this.shop.branchName,
        },
        shopId: this.shop.id,
        stockDocType: 2,
        vatBase: 7,
        uid: this.uid,
        vat: this.vat,
        items: this.items,
        vatType: this.vatType,
        category: this.category ? { id: this.category.id, name: this.category.name } : null,

      }
      if (this.member != null) {
        data['customerId'] = this.member.id || ''
        data['customer'] = {
          id: this.member.id || '',
          objectId: this.member.objectId || '',
          name: this.member.name || '',
        }
      }

      const headers = {
        shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
      }
      if (data.shopId != undefined && data.items.length != 0) {
        axios({
          method: 'post',
          url: '/api/v1.0/' + data.uid + '/stockdocument/save',
          params: { shopObjectId: data.shopObjectId, plan: plan },
          data: data,
          headers: headers,
        })
          .then(() => {
            //   setTimeout(() => {
            this.isSuccess = true
            // ,
            this.$router.push('/inventory/stock-out')
            // }, 5000)
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    reset() {
      this.selectedItems = []
      this.all = false
      this.keywordEntered = ''
      this.searchBy = 'name'
      this.selectedCategory = ''
      this.searchProductPLU()
    },
    onCheckboxChange() {
      let data = this.selectedItems
      let items = this.items
      let select = []
      data.forEach(function (item, index) {
        let stdCost = 0
        let SKURatio = 1
        let totalCost = 0
        if (item.selected) {
          select.push(item)
          if (
            item.ProductSKU.stdCost === undefined ||
            item.ProductSKU.stdCost === null
          ) {
            stdCost = 0
          } else {
            stdCost = item.ProductSKU.stdCost
          }

          if (item.SKURatio == undefined) {
            SKURatio = 1
          } else {
            SKURatio = item.SKURatio
          }

          totalCost = SKURatio * stdCost
          let checkCount = item.checkCount;
          let quantity = checkCount !== undefined ? checkCount : 0;
          let vatType = item.ProductSKU.vatType
          if (items.length > 0) {
            let i = items.findIndex(
              (x) => x.productPLU.objectId === item.objectId
            )
            if (i == -1) {
              items.push({
                docNo: item.docNo,
                cost: totalCost,
                discount: 0,
                orderIndex: index,
                productPLU: {
                  id: item.id,
                  objectId: item.objectId,
                  PLUCode: item.PLUCode,
                  name: item.name,
                  unit: item.unit,
                  SKURatio: SKURatio,
                },
                productPLUId: item.id,
                quantity: quantity,
                total: 0,
                productSKUObjectId: item.ProductSKU.objectId,
                productSKU: item.ProductSKU || {},
                remoteImagePath: item.remoteImagePath,
                indexColor: util.generateColor(item.indexColor),
                vatType: vatType
              })
            }
          } else {
            items.push({
              docNo: item.docNo,
              cost: totalCost,
              discount: 0,
              orderIndex: index,
              productPLU: {
                id: item.id,
                objectId: item.objectId,
                PLUCode: item.PLUCode,
                name: item.name,
                unit: item.unit,
                SKURatio: SKURatio,
              },
              productPLUId: item.id,
              quantity: quantity,
              total: 0,
              productSKUObjectId: item.ProductSKU.objectId,
              productSKU: item.ProductSKU || {},
              remoteImagePath: item.remoteImagePath,
              indexColor: util.generateColor(item.indexColor),
              vatType: vatType
            })
          }
        } else {
          let index = items.findIndex(
            (x) => x.productPLU.objectId === item.objectId
          )
          if (index != -1) {
            items.splice(index, 1)
          }

        }
      })
      this.items = items
      this.selectedItems = select
      this.AddProductModal = false
      this.AddCheckStockModal = false
      this.all = false
    },
    setAll() {
      let select = this.selectedItems
      let data = this.autoCompleteResult
      // this.selectedItems = []
      if (this.all) {
        this.checkAllAlert = true
        data.forEach(function (item) {
          if (item.inDocument) return
          item.selected = true
          if (select.findIndex(x => x.objectId === item.objectId) === -1) select.push(item)
        })
      } else {
        this.checkAllAlert = false
        data.forEach(function (item) {
          if (item.inDocument) return
          item.selected = false
          let i = select.findIndex((x) => x.objectId === item.objectId)
          if (i != -1) {
            select.splice(i, 1)
          }
        })
      }
      this.selectedItems = select
      this.autoCompleteResult = data
    },
    floatValue(value) {
      return parseFloat(value)
    }
  },
}
</script>
<style scoped>
.multiselect__tags {
  min-height: 35px;
  padding: 0px 40px 0 8px;
}

.multiselect__placeholder {
  margin-top: 6px;
  margin-bottom: 7px;
}

.multiselect__single {
  margin-top: 6px;
  padding-left: 5px;
  margin-bottom: 8px;
}

/* Hidden arrow  */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="../../../assets/styles/inventory.css" scoped></style>
